export class RQuestion {
  Title: string;
  Options: string[];
  Type: string;
}
